import { render, staticRenderFns } from "./PriceList.vue?vue&type=template&id=1ff3c8da&scoped=true"
import script from "./PriceList.vue?vue&type=script&lang=js"
export * from "./PriceList.vue?vue&type=script&lang=js"
import style0 from "./PriceList.vue?vue&type=style&index=0&id=1ff3c8da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff3c8da",
  null
  
)

export default component.exports